// Copyright (c) 2017 Deere & Company

import PipSearchBox from '../../../shared/components/pip-search-box';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    searchByDropDown: state.pips.openPips.searchByDropDown,
    searchQueryString: state.pips.openPips.searchQueryString
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(PipSearchBox);



// WEBPACK FOOTER //
// ./src/pip/open-pips/components/open-pips-main/open-pips-search-box.js